import React from 'react';
import { Tag, MessageSquare, PersonStanding, User, Phone } from 'lucide-react';
import { useVendorContext } from '../../context/VendorContext';
import './VendorHeader.css';

const VendorHeader = ({ vendor }) => {
  const { addMessage } = useVendorContext();

  const handleAddLog = async () => {
    await addMessage(vendor.id, {
      type: 'log',
      text: 'New log entry',
      user: 'You'
    });
  };

  const handleAddEvent = async () => {
    await addMessage(vendor.id, {
      type: 'event',
      text: 'New event',
      user: 'You'
    });
  };
  /*
    return (
      <div className="vendor-header">
        <h2>{vendor.name}</h2>
        <div className="vendor-actions">
          <button onClick={handleAddLog} className="action-btn log-btn">
            <MessageSquare /> Add Log
          </button>
          <button onClick={handleAddEvent} className="action-btn event-btn">
            <Tag /> Add Event
          </button>
        </div>
      </div>
    );*/
  return (
    <div className="vendor-header">
      {/* LEFT COLUMN */}
      <div className="vendor-main">
        <h2 className="vendor-name">{vendor.name}</h2>
        <div className="vendor-actions">
          {vendor.description}
        </div>
    {/*
        <div className="vendor-actions">
          <button onClick={handleAddLog} className="action-btn log-btn" disabled>
            <MessageSquare size={16} /> Add Log
          </button>
          <button onClick={handleAddEvent} className="action-btn event-btn" disabled>
            <Tag size={16} /> Add Event
          </button>
        </div>*/}
      </div>

      {/* RIGHT COLUMN */}
      <div className="vendor-profile">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#6b7280', marginBottom: '2px' }}>
          <User size={16} /> <span>Contact</span>
          
          <div style={{ padding: '3px 8px 3px 8px', backgroundColor: 'white', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '14px', color: '#111827' }}> {vendor.contact_Name||''} {' ('+vendor.contact_Designation+')'||''}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#6b7280', marginBottom: '2px' }}>
          <Phone size={16} /> <span style={{paddingRight:'4px'}}>Mobile</span>
          <div style={{ padding: '3px 8px 3px 8px', backgroundColor: 'white', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '14px', color: '#111827' }}>{vendor.contact_Mobile||''}</div>
        </div>
      </div>

    </div>
  );


};

export default VendorHeader;